// extracted by mini-css-extract-plugin
export default {"main":"FullScreen_main__9iNUh"};